<div class="p-booking-info-mdl__additional-item">
  <button
    id="{{ id }}-passenger-support-open-button"
    class="p-booking-info-mdl__additional-open"
    [ngClass]="{ 'is-open': isOpen }"
    aria-controls="additional4"
    [attr.aria-expanded]="isOpen"
    (click)="showSupport()"
  >
    <span
      class="p-booking-info-mdl__additional-open-title"
      [innerHTML]="'label.needSpecialAssistance' | staticMsg"
    ></span>

    <span class="p-booking-info-mdl__additional-open-icon"
      ><img src="assets/images/icon_add_primary_20.svg" width="20" height="20" [alt]="'label.open' | staticMsg"
    /></span>
  </button>
  <div id="additional4" class="p-booking-info-mdl__contents" [ngClass]="{ 'is-open': isOpen }">
    <div id="additional4" class="p-booking-info-mdl__contents" [ngClass]="{ 'is-open': isOpen }">
      <div class="p-booking-info-mdl__section">
        <div class="p-booking-info-mdl__block">
          <div
            class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01 p-booking-info-mdl__heading--has-edit"
          >
            <h3
              class="p-booking-info-mdl__heading-title"
              [innerHTML]="'label.supportInformation.title1' | staticMsg"
            ></h3>
            <span class="c-text-with-tooltip__tooltip">
              <!--ヘルプアイコン ※サポート情報見出し -->
              <asw-tooltip
                iconImage='<img src="assets/images/icon_help_primary_20.svg" width="20" height="20" alt="help" />'
                [tooltipContent]="'tooltip.supportInformation' | staticMsg"
                displayAreaClass="p-booking-info-mdl"
              ></asw-tooltip>
            </span>
            <div class="p-booking-info-mdl__heading-btn">
              <asw-button
                id="{{ id }}-edit-button"
                size="xs"
                [label]="'label.editSupportInformation' | staticMsg"
                (click$)="editSupport()"
              >
              </asw-button>
            </div>
          </div>
          <div class="p-booking-info-mdl__row">
            <div class="p-booking-info-mdl__support">
              <dl class="c-def-list02">
                <div class="c-def-list02__item" *ngIf="data.walk">
                  <dt class="c-def-list02__item-title" [innerHTML]="'label.degreeOfWalking' | staticMsg"></dt>
                  <dd class="c-def-list02__item-body">
                    <dl class="c-float-list01">
                      <div class="c-float-list01__item" *ngIf="data.walkLevel !== ''">
                        <dt class="c-float-list01__title" [innerHTML]="'label.walking.ability' | staticMsg"></dt>
                        <dd
                          class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                          [innerHTML]="data.walkLevelDisplayValue"
                        ></dd>
                      </div>
                      <div class="c-float-list01__item" *ngIf="data.bringWheelchairDisplayValue !== ''">
                        <dt class="c-float-list01__title" [innerHTML]="'label.useWheelchair' | staticMsg"></dt>
                        <dd
                          class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                          [innerHTML]="data.bringWheelchairDisplayValue | staticMsg"
                        ></dd>
                      </div>
                      <div
                        class="c-float-list01__item"
                        *ngIf="data.bringWheelchair && data.wheelchairFoldableDisplayValue !== ''"
                      >
                        <dt class="c-float-list01__title" [innerHTML]="'label.foldingWheelchair' | staticMsg"></dt>
                        <dd
                          class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                          [innerHTML]="data.wheelchairFoldableDisplayValue | staticMsg"
                        ></dd>
                      </div>
                      <div
                        class="c-float-list01__item"
                        *ngIf="data.bringWheelchair && data.wheelchairFoldable === false"
                      >
                        <dt class="c-float-list01__title" [innerHTML]="'label.size' | staticMsg"></dt>
                        <dd
                          class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                          [innerHTML]="
                            'label.wheelchairSize'
                              | staticMsg
                                : {
                                    '0': data.wheelchairDepth,
                                    '1': data.wheelchairWidth,
                                    '2': data.wheelchairHeight
                                  }
                          "
                        ></dd>
                      </div>
                      <div
                        class="c-float-list01__item"
                        *ngIf="data.bringWheelchair && data.wheelchairFoldable === false"
                      >
                        <dt class="c-float-list01__title" [innerHTML]="'label.weight' | staticMsg"></dt>
                        <dd
                          class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                          [innerHTML]="'label.wheelchairWeight' | staticMsg : { '0': data.wheelchairWeight }"
                        ></dd>
                      </div>
                      <div
                        class="c-float-list01__item"
                        *ngIf="data.bringWheelchair && data.wheelchairTypeDisplayValue !== ''"
                      >
                        <dt class="c-float-list01__title" [innerHTML]="'label.wheelchairType' | staticMsg"></dt>
                        <dd
                          class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                          [innerHTML]="data.wheelchairTypeDisplayValue | staticMsg"
                        ></dd>
                      </div>
                      <div
                        class="c-float-list01__item"
                        *ngIf="data.bringWheelchair && data.wheelchairType === 'battery'"
                      >
                        <dt class="c-float-list01__title" [innerHTML]="'label.batteryType' | staticMsg"></dt>
                        <dd
                          class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                          [innerHTML]="data.wheelchairBatteryTypeDisplayValue"
                        ></dd>
                      </div>
                    </dl>
                  </dd>
                </div>
                <div class="c-def-list02__item c-def-list02__item--one" *ngIf="data.blind">
                  <dt class="c-def-list02__item-title" [innerHTML]="'label.blind' | staticMsg"></dt>
                  <dd class="c-def-list02__item-body">
                    <span [innerHTML]="'label.applicable' | staticMsg"></span>
                  </dd>
                </div>
                <div class="c-def-list02__item c-def-list02__item--one" *ngIf="data.deaf">
                  <dt class="c-def-list02__item-title" [innerHTML]="'label.deaf' | staticMsg"></dt>
                  <dd class="c-def-list02__item-body">
                    <span [innerHTML]="'label.applicable' | staticMsg"></span>
                  </dd>
                </div>
                <div class="c-def-list02__item" *ngIf="data.isPregnant">
                  <dt class="c-def-list02__item-title" [innerHTML]="'label.pregnant' | staticMsg"></dt>
                  <dd class="c-def-list02__item-body">
                    <dl class="c-float-list01">
                      <div class="c-float-list01__item">
                        <dt class="c-float-list01__title" [innerHTML]="'label.doctorName' | staticMsg"></dt>
                        <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
                          {{ data.doctorName }}
                        </dd>
                      </div>
                      <div class="c-float-list01__item">
                        <dt class="c-float-list01__title" [innerHTML]="'label.doctorsContact' | staticMsg"></dt>
                        <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
                          {{ data.doctorPhoneNumber }}
                        </dd>
                      </div>
                      <div class="c-float-list01__item">
                        <dt class="c-float-list01__title" [innerHTML]="'label.expectedDate' | staticMsg"></dt>
                        <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
                          {{
                            ((data.pregnantDueDate ?? '' | date : 'yyyy-MM-dd') ?? ''
                              | dateFormat : 'default_datetime.selectedFlightDate') ?? ''
                          }}
                        </dd>
                      </div>
                      <div class="c-float-list01__item">
                        <dt class="c-float-list01__title" [innerHTML]="'label.condition' | staticMsg"></dt>
                        <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
                          {{ data.pregnantConditionDisplayValue }}
                        </dd>
                      </div>
                    </dl>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
